import React from "react";

export enum EstimateFieldsForExportHeader {
	ProjectName = "projectName",
	PropertyAddress = "propertyAddress",
	Assignee = "assignee",
	CurrentDate = "currentDate",
	OrganizationName = "organizationName",
}

export interface HeaderInfoItem {
	key: string;
	estimateField: EstimateFieldsForExportHeader;
}

interface HeaderInfoFieldProps {
	items: HeaderInfoItem[];
	onAdd: () => void;
	onChange: (index: number, item: HeaderInfoItem) => void;
	onRemove: (index: number) => void;
	emptyMessage?: string;
}

const HeaderInfoField: React.FC<HeaderInfoFieldProps> = ({
	items,
	onAdd,
	onChange,
	onRemove,
	emptyMessage = "No header info items added",
}) => {
	return (
		<div className="p-4 bg-white rounded-lg border border-gray-200">
			<div className="flex justify-between items-start mb-2">
				<div className="flex-1">
					<label className="text-gray-900 text-base font-medium font-['Hanken Grotesk'] block mb-1">
						Header Info (label-estimate field pairs)
					</label>
					<span className="text-gray-500 text-xs font-normal block">
						Add info to header of PDF export config. Enter a string that will be on the left side of the text and estimate value
						that will be on the right. For example: <span className="italic">"Estimator"</span> on the left and{" "}
						<span className="italic">Assignee</span> on the right.
					</span>
				</div>
				<button type="button" onClick={onAdd} className="text-blue-600 hover:text-blue-800 text-sm font-medium ml-4">
					+ Add Item
				</button>
			</div>
			{items.map((item, index) => (
				<div key={index} className="flex gap-2 mb-2">
					<input
						type="text"
						value={item.key}
						onChange={(e) => onChange(index, { ...item, key: e.target.value })}
						className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
						placeholder="e.g., Customer Name"
					/>
					<select
						value={item.estimateField}
						onChange={(e) => onChange(index, { ...item, estimateField: e.target.value as EstimateFieldsForExportHeader })}
						className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
					>
						<option value={EstimateFieldsForExportHeader.ProjectName}>Project Name</option>
						<option value={EstimateFieldsForExportHeader.PropertyAddress}>Property Address</option>
						<option value={EstimateFieldsForExportHeader.Assignee}>Assignee</option>
						<option value={EstimateFieldsForExportHeader.CurrentDate}>Current Date</option>
						<option value={EstimateFieldsForExportHeader.OrganizationName}>Organization Name</option>
					</select>
					<button type="button" onClick={() => onRemove(index)} className="px-3 py-2 text-red-600 hover:text-red-800">
						Remove
					</button>
				</div>
			))}
			{items.length === 0 && <div className="text-gray-500 text-sm">{emptyMessage}</div>}
		</div>
	);
};

export default HeaderInfoField;
